import * as React from 'react';

type TwitterProps = {
  width?: number;
  height?: number;
};

// tslint:disable:max-line-length
export const Twitter = (props: TwitterProps) => (
  <svg width={props.width || 16} height={props.height || 14} viewBox='0 0 16 14' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M15.5587.58038c-.634822.38491-1.336288.665154-2.086028.81553-.597228-.654047-1.450778-1.062452-2.39575-1.062452-1.811336 0-3.281338 1.50717-3.281338 3.365925 0 .26401.028195.520332.084586.766828-2.728113-.140548-5.146504-1.4794-6.766454-3.518008-.282808.498972-.44429 1.077403-.44429 1.693856 0 1.167116.579286 2.197955 1.460604 2.80159-.53742-.016232-1.04451-.169598-1.487945-.419938v.041438c0 1.631485 1.131658 2.992124 2.634555 3.300564-.275118.078605-.565616.118335-.865084.118335-.211465 0-.417804-.02008-.617734-.05981.417803 1.336717 1.629348 2.31031 3.06603 2.33637-1.123115.903532-2.53929 1.441807-4.07679 1.441807-.264866 0-.52674-.01538-.783062-.046138 1.452487.953515 3.17881 1.511014 5.032013 1.511014 6.038502 0 9.339493-5.12856 9.339493-9.57659 0-.14653-.002564-.29306-.008117-.4366.64123-.474622 1.1983-1.06715 1.63661-1.74213-.58783.267855-1.220944.44899-1.884816.52973.67797-.416095 1.198302-1.075695 1.443516-1.86132'
      fill='#FFF'
      fillRule='evenodd'
    />
  </svg>  
);



// WEBPACK FOOTER //
// src/app/src/components/Icons/Twitter.tsx